exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7fe5e0dc] .el-table thead.is-group th{background-color:#f7fbff;border-color:#fff}[data-v-7fe5e0dc] .el-table{border:none}[data-v-7fe5e0dc] .el-table td{border:none}\n", ""]);

// exports
